<div class="flex min-h-8 min-w-8 flex-col py-4">
  <div>IQ Observation</div>
  <p class="text-xs italic text-gray-400"></p>
  <div class="mt-2 flex justify-start">
    <div
      class="mr-2.5 h-8 min-h-8 w-8 min-w-8 overflow-hidden rounded-full border border-blue-950 transition-[border] duration-300 ease-in-out hover:border-orange-500"
    >
      <span
        ><img
          alt="Robot Icon"
          src="assets/images/robot-solid.svg"
          class="pointer-events-none max-h-full max-w-full"
      /></span>
    </div>
    @if (isLoading) {
      <mat-progress-bar class="mt-4 w-full" mode="buffer"></mat-progress-bar>
      <div class="flex text-xs">
        <mat-progress-bar
          class="mt-4 w-full"
          mode="indeterminate"
        ></mat-progress-bar>
      </div>
    } @else {
      <div class="flex items-center pt-0.5 text-xs font-semibold">
        @if (summary) {
          <span>
            {{ summary }}
            @if (historicalObservations?.length > 0) {
              <a
                href="javascript:void(0)"
                class="ml-2 text-blue-600 underline"
                (click)="openSummaryModal(ticket.Service__r.Name)"
                >Additional information can be found here.</a
              >
            }
          </span>
        } @else {
          No summary available.
        }
      </div>
    }
  </div>
</div>
